import {
	EnvironmentOutlined,
	HomeOutlined,
	MailOutlined,
	PhoneOutlined,
} from "@ant-design/icons";
import { Card, Descriptions, Empty, List, Spin } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { getClientAddressesByNo } from "../../services/clientAddressService";

const ClientAddressList = ({ clientNo, clientName }) => {
	const [addresses, setAddresses] = useState([]);
	const [loading, setLoading] = useState(false);

	const loadClientAddresses = useCallback(async () => {
		try {
			setLoading(true);
			const clientAddresses = await getClientAddressesByNo(clientNo);
			setAddresses(clientAddresses);
		} catch (error) {
			console.error("Error al cargar direcciones del cliente:", error);
			window.messageApi.error("Error al cargar direcciones del cliente");
			setAddresses([]);
		} finally {
			setLoading(false);
		}
	}, [clientNo]);

	useEffect(() => {
		if (clientNo) {
			loadClientAddresses();
		} else {
			setAddresses([]);
		}
	}, [clientNo, loadClientAddresses]);

	if (loading) {
		return <Spin size="large" />;
	}

	if (!clientNo) {
		return (
			<Card>
				<Empty description="Seleccione un cliente para ver sus direcciones" />
			</Card>
		);
	}

	if (addresses.length === 0) {
		return (
			<Card title={`Direcciones de ${clientName || clientNo}`}>
				<Empty description="Este cliente no tiene direcciones registradas" />
			</Card>
		);
	}

	return (
		<Card title={`Direcciones de ${clientName || clientNo}`}>
			<List
				grid={{
					gutter: 16,
					xs: 1,
					sm: 1,
					md: 1,
					lg: 1,
					xl: 1,
					xxl: 1,
				}}
				dataSource={addresses}
				renderItem={(address) => (
					<List.Item>
						<Card
							size="small"
							title={
								<div style={{ display: "flex", alignItems: "center" }}>
									<HomeOutlined style={{ marginRight: 8 }} />
									{address.Name}
								</div>
							}
							extra={
								<span style={{ fontSize: "12px", color: "#666" }}>
									{address.Code}
								</span>
							}
						>
							<Descriptions
								size="small"
								column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}
							>
								<Descriptions.Item
									label={
										<span>
											<EnvironmentOutlined style={{ marginRight: 4 }} />
											Ciudad
										</span>
									}
								>
									{address.Ciudad || "No especificada"}
								</Descriptions.Item>

								<Descriptions.Item
									label={
										<span>
											<EnvironmentOutlined style={{ marginRight: 4 }} />
											Provincia
										</span>
									}
								>
									{address.Provincia || "No especificada"}
								</Descriptions.Item>

								{address.Teléfono && (
									<Descriptions.Item
										label={
											<span>
												<PhoneOutlined style={{ marginRight: 4 }} />
												Teléfono
											</span>
										}
									>
										{address.Teléfono}
									</Descriptions.Item>
								)}

								{address.Email && (
									<Descriptions.Item
										label={
											<span>
												<MailOutlined style={{ marginRight: 4 }} />
												Email
											</span>
										}
									>
										{address.Email}
									</Descriptions.Item>
								)}
							</Descriptions>
						</Card>
					</List.Item>
				)}
			/>
		</Card>
	);
};

export default ClientAddressList;
